"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dataCy = exports.SidePage = void 0;
var _react = require("react");
var _Backdrop = _interopRequireDefault(require("../Backdrop"));
var _View = _interopRequireDefault(require("../View"));
var _Modal = _interopRequireDefault(require("@mui/material/Modal"));
var _Paper = _interopRequireDefault(require("@mui/material/Paper"));
var _Slide = _interopRequireDefault(require("@mui/material/Slide"));
var _styles = require("@mui/styles");
var _clsx3 = _interopRequireDefault(require("clsx"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["children", "width", "fullScreen", "backdrop", "loading", "fetching", "onClose", "onExited", "active", "open", "swap", "size", "direction", "directionOfset", "className", "transitionDuration", "isolatedView", "zIndex"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var SIZES = {
  xl: 1120,
  lg: 960,
  md: 720,
  m: 640,
  sm: 480,
  xs: 340
};
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      zIndex: function zIndex(_ref) {
        var _zIndex = _ref.zIndex;
        return _zIndex !== undefined ? _zIndex : theme.zIndex.drawer + 2;
      },
      marginTop: '0!important',
      // margin set by Stack should be omitted
      right: function right(_ref2) {
        var direction = _ref2.direction,
          directionOfset = _ref2.directionOfset;
        return direction === 'left' ? "".concat(directionOfset ? directionOfset : 0) : 0;
      },
      left: function left(_ref3) {
        var direction = _ref3.direction,
          directionOfset = _ref3.directionOfset;
        return direction === 'right' ? "".concat(directionOfset ? directionOfset : 0) : 0;
      }
    },
    position: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column'
    },
    slide: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      position: 'absolute',
      top: "0",
      right: function right(_ref4) {
        var direction = _ref4.direction;
        return direction === 'left' ? 0 : 'auto';
      },
      left: function left(_ref5) {
        var direction = _ref5.direction;
        return direction === 'right' ? 0 : 'auto';
      },
      width: function width(_ref6) {
        var _width = _ref6.width;
        return "".concat(isNaN(_width) ? _width : _width + 'px');
      }
    },
    paper: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      pointerEvents: 'auto',
      marginRight: function marginRight(_ref7) {
        var swap = _ref7.swap;
        return swap ? "16px" : '0';
      }
    },
    rightShadow: {
      boxShadow: '2px 0px 3px -2px rgba(0,0,0,0.2), 2px 0px 3px -2px rgba(0,0,0,0.14), 2px 0px 3px -2px rgba(0,0,0,0.12)'
    },
    view: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1
    },
    noBlockOutSide: {
      pointerEvents: 'none'
    }
  };
});
var TRANSITION_DURATION = 250;
var dataCy = exports.dataCy = 'SidePage';
var SidePage = exports.SidePage = function SidePage(_ref8) {
  var children = _ref8.children,
    width = _ref8.width,
    fullScreen = _ref8.fullScreen,
    _ref8$backdrop = _ref8.backdrop,
    backdrop = _ref8$backdrop === void 0 ? true : _ref8$backdrop,
    _ref8$loading = _ref8.loading,
    loading = _ref8$loading === void 0 ? false : _ref8$loading,
    _ref8$fetching = _ref8.fetching,
    fetching = _ref8$fetching === void 0 ? false : _ref8$fetching,
    onClose = _ref8.onClose,
    onExited = _ref8.onExited,
    active = _ref8.active,
    open = _ref8.open,
    _ref8$swap = _ref8.swap,
    swap = _ref8$swap === void 0 ? false : _ref8$swap,
    _ref8$size = _ref8.size,
    size = _ref8$size === void 0 ? 'md' : _ref8$size,
    _ref8$direction = _ref8.direction,
    direction = _ref8$direction === void 0 ? 'left' : _ref8$direction,
    directionOfset = _ref8.directionOfset,
    className = _ref8.className,
    _ref8$transitionDurat = _ref8.transitionDuration,
    transitionDuration = _ref8$transitionDurat === void 0 ? TRANSITION_DURATION : _ref8$transitionDurat,
    _ref8$isolatedView = _ref8.isolatedView,
    isolatedView = _ref8$isolatedView === void 0 ? true : _ref8$isolatedView,
    zIndex = _ref8.zIndex,
    props = _objectWithoutProperties(_ref8, _excluded);
  var modalRef = (0, _react.useRef)(null);
  var classes = useStyles({
    width: fullScreen ? '100%' : width || SIZES[size],
    swap: swap,
    transitionDuration: TRANSITION_DURATION,
    direction: direction,
    directionOfset: directionOfset,
    zIndex: zIndex
  });
  var invisible = (0, _react.useMemo)(function () {
    return !backdrop;
  }, [backdrop]);
  var isInternal = (0, _react.useCallback)(function (e) {
    var _modalRef$current, _modalRef$current$con;
    var pointElements = document.elementsFromPoint(e.x, e.y) || [];
    return (modalRef === null || modalRef === void 0 || (_modalRef$current = modalRef.current) === null || _modalRef$current === void 0 || (_modalRef$current$con = _modalRef$current.contains) === null || _modalRef$current$con === void 0 ? void 0 : _modalRef$current$con.call(_modalRef$current, e.target)) || Array.from(pointElements).some(function (el) {
      var _modalRef$current2;
      return modalRef === null || modalRef === void 0 || (_modalRef$current2 = modalRef.current) === null || _modalRef$current2 === void 0 ? void 0 : _modalRef$current2.contains(el);
    });
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal["default"], {
    open: open,
    onClose: onClose,
    BackdropComponent: _Backdrop["default"],
    BackdropProps: {
      transitionDuration: transitionDuration,
      invisible: invisible,
      isInternal: isInternal,
      onClose: onClose,
      active: active,
      directionOfset: directionOfset,
      direction: direction
    },
    disableEscapeKeyDown: !active,
    disablePortal: true,
    className: (0, _clsx3["default"])(_defineProperty(_defineProperty({}, classes.noBlockOutSide, invisible), classes.root, true)),
    ref: modalRef,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Slide["default"], {
      direction: direction,
      "in": open,
      timeout: transitionDuration,
      onExited: onExited,
      className: classes.slide,
      "data-cy": dataCy,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({
        className: classes.position
      }, props), {}, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Paper["default"], {
          elevation: 4,
          square: true,
          className: (0, _clsx3["default"])(classes.paper, _defineProperty({}, classes.rightShadow, directionOfset)),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_View["default"], {
            loading: loading,
            fetching: fetching,
            direction: 'column',
            className: (0, _clsx3["default"])(classes.view, className),
            grow: true,
            "data-cy-role": 'sidePageView',
            isolated: isolatedView,
            children: children
          })
        })
      }))
    })
  });
};